import Vue from 'vue'
import App from './App.vue'
import router from './router'


// import { BootstrapVue, IconsPlugin, DropdownPlugin, TablePlugin } from 'bootstrap-vue'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// import ECharts from 'vue-echarts'
// import 'echarts/lib/chart/line'
// import "echarts/lib/chart/bar";
// import "echarts/lib/chart/candlestick";
// import 'echarts/lib/component/title'
// import "echarts/lib/component/dataZoom";
// import "echarts/lib/component/axis";
// import "echarts/lib/component/axisPointer";
// import "echarts/lib/component/tooltip";
// import "echarts/lib/component/toolbox";
// import "echarts/lib/component/legend";
// import "echarts/lib/component/markLine";
// import "echarts/lib/component/markPoint";
// import "echarts/lib/component/markArea";
// import "echarts/lib/component/timeline";
// import "echarts/lib/component/visualMap";

// Vue.component('v-chart', ECharts)

import ECharts from 'vue-echarts' // 在 webpack 环境下指向 components/ECharts.vue
// 注册组件后即可使用
Vue.component('v-chart', ECharts)

// Vue.use(BootstrapVue)
// Vue.use(IconsPlugin)
// Vue.use(DropdownPlugin)
// Vue.use(TablePlugin)

// 域名规范化：若用户通过 www.zizizaizai.com 或 zizizaizai.com 访问，自动跳转至 quant.zizizaizai.com
if (typeof window !== 'undefined' && window.location) {
	const host = window.location.hostname
	if (host === 'www.zizizaizai.com' || host === 'zizizaizai.com') {
		window.location.replace(`https://quant.zizizaizai.com${window.location.pathname}${window.location.search}${window.location.hash}`)
	}
}

router.beforeEach((to, fr, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
})

router.afterEach((to) => {
	if (window._hmt) {
		window._hmt.push(['_trackPageview', to.fullPath]);
	}
})

new Vue({
	render: h => h(App),
	router,
}).$mount('#app')
